export default function HttpLayer(Authentication, Utils, $http) {
  'ngInject';

  return {
    httpGet(url, params = {}, httpConfig = {}) {
      const _httpConfig = Object.assign(
        {
          method: 'GET',
          url: `${getUrl(url, httpConfig)}${Utils.resolveQueryParams(params)}`,
          headers: {
            Authorization: Authentication.token,
          },
        },
        httpConfig
      );

      return $http(_httpConfig).then((d) => d.data);
    },
    httpPost(url, body = {}, params = {}, httpConfig = {}, headers = {}) {
      if (url.includes('analytics.getsling.com')) {
        return fetch(url, {
          method: 'POST',
          body: JSON.stringify(body),
          mode: 'no-cors',
        });
      }

      const _httpConfig = Object.assign(
        {
          method: 'POST',
          url: `${getUrl(url, httpConfig)}${Utils.resolveQueryParams(params)}`,
          data: body,
          headers: {
            Authorization: Authentication.token,
            ...headers,
          },
        },
        httpConfig
      );

      return $http(_httpConfig).then((d) => d.data);
    },
    httpPut(url, body = {}, params = {}, httpConfig = {}) {
      const _httpConfig = Object.assign(
        {
          method: 'PUT',
          url: `${getUrl(url, httpConfig)}${Utils.resolveQueryParams(params)}`,
          data: body,
          headers: {
            Authorization: Authentication.token,
          },
        },
        httpConfig
      );

      return $http(_httpConfig).then((d) => d.data);
    },
    httpDelete(url, params = {}, httpConfig = {}) {
      const _httpConfig = Object.assign(
        {
          method: 'DELETE',
          url: `${getUrl(url, httpConfig)}${Utils.resolveQueryParams(params)}`,
          headers: {
            Authorization: Authentication.token,
          },
        },
        httpConfig
      );

      return $http(_httpConfig).then((d) => d.data);
    },
  };

  function getUrl(url, httpConfig) {
    return httpConfig.noPrefix ? url : `${Authentication.baseUrl}${url}`;
  }
}
